import React from 'react'
import { ButtonSelectCourse } from '../ButtonSelectCourse'
import { SelectCourseStyle } from './style'

type ICourses = {
  courseName: string
}

type SelectCourseProps = React.FC<{
  setCourses: React.Dispatch<React.SetStateAction<ICourses[]>>
  courses: ICourses[]
  setValidateCourses: React.Dispatch<React.SetStateAction<boolean>>
}>

export const SelectCourse: SelectCourseProps = ({ setCourses, courses, setValidateCourses }) => {
  return (
    <SelectCourseStyle>
      <label>Clique no curso em que tem interesse (você poderá escolher apenas um ou ambos)</label>
      <div>
        <ButtonSelectCourse
          setCourses={setCourses}
          courses={courses}
          text="MBA em Ciclo de Receitas Hospitalares"
          setValidateCourses={setValidateCourses}
        />
        <ButtonSelectCourse
          setCourses={setCourses}
          courses={courses}
          text="MBA em Gestão de Custos Hospitalares"
          setValidateCourses={setValidateCourses}
        />
      </div>
    </SelectCourseStyle>
  )
}
